<template>
  <div>
    <div class="card collapse-header">
      <div
        id="heading5"
        class="card-header"
        data-toggle="collapse"
        :data-target="`#accordion-${city.replaceAll(' ', '_')}`"
        aria-expanded="false"
        aria-controls="accordion5"
        role="tablist"
      >
        <span class="collapse-title">
          <span class="align-middle"
            >{{ city }}
            <span class="badge badge-secondary" style="float: right">{{
              data.total
            }}</span></span
          >
        </span>
      </div>
      <div
        :id="`accordion-${city.replaceAll(' ', '_')}`"
        role="tabpanel"
        data-parent="#accordionWrapa2"
        aria-labelledby="heading5"
        class="collapse"
      >
        <div class="card-content">
          <div class="card-body pt-2">
            <div
              class="d-flex activity-content"
              v-for="(property, index) of data.counts"
              :key="index"
            >
              <div
                class="activity-progress flex-grow-1"
                v-for="(count, type) of property"
                :key="type"
              >
                <small class="text-muted d-inline-block mb-50 capitalize">{{
                  type
                }}</small>
                <small class="float-right">{{ count }}</small>
                <div class="progress progress-bar-default progress-sm">
                  <div
                    class="progress-bar"
                    role="progressbar"
                    aria-valuenow="50"
                    :style="`width: ${(count * 100) / data.total}%`"
                  ></div>
                </div>
                <small>{{ (count * 100) / data.total }}%</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["city", "data"],
};
</script>

